import {axiosGetAuthorize,// TO DO unused import // TO DO lazy load component
     axiosPostAuthorize} from '../AxiosRequests';
import {AddInquiryResponseProductQuantities,UpdateInquiryResponseProductQuantities,DeleteInquiryResponseProductQuantitiesById} from '../ApiEndPoints';

export default class InquiryResponseProductQuantityServices {
    
     //** Call API : */
     async addInquiryResponseProductQuantities(request){
        return axiosPostAuthorize(AddInquiryResponseProductQuantities, request);
    }

    async updateInquiryResponseProductQuantities(request){
        return axiosPostAuthorize(UpdateInquiryResponseProductQuantities, request);
    }

    async deleteInquiryResponseProductQuantitiesById(request){
        return axiosPostAuthorize(DeleteInquiryResponseProductQuantitiesById, request);
    }

}
